<template>
  <div class="flex flew-row w-full md:relative">
    <div :class="[drawerCondition ? isOpen ? 'animate-slide-in-margin-draft' : 'animate-slide-out-margin-draft' : null]" class="md:grow z-20">
      <slot name="content"/>
    </div>

    <div v-if="drawerCondition">
      <div v-if="isOpen" class="top-16 md:top-0 right-0 fixed flex flex-col pt-4 items-center z-30
      bottom-0 bg-[#E7E7E7] h-auto border rounded-xl" :class="[isOpen ? 'animate-slide-in-draft' : 'animate-slide-out-draft']">

        <BlackCrossIcon @click="toogleOpen" class="absolute left-4 !text-3xl" />

        <div class="mt-10 w-screen md:w-full">
          <slot name="drawer"/>
        </div>
      </div>

      <font-awesome-icon icon="fas fa-bars" class="fixed top-0 right-0 md:relative text-3xl mt-4 md:mt-8 mr-4 md:text-black text-white z-50" @click="toogleOpen()" v-show="!isOpen"/>
    </div>
  </div>
</template>

<script setup>

import {defineProps, ref} from "vue";
import BlackCrossIcon from "@/components/atoms/BlackCrossIcon.vue";

const props = defineProps({
  drawerName: {
    type: String,
    required: true
  },
  defaultIsOpen: {
    type: Boolean,
    default: false
  },
  drawerCondition: {
    type: Boolean,
    default: true
  }
})

const fullDrawerName = `drawer-${props.drawerName}`;
const isOpenPreviously = localStorage.getItem(fullDrawerName);

if(!isOpenPreviously) {
  localStorage.setItem(fullDrawerName, props.defaultIsOpen);
}

const isOpen = ref(isOpenPreviously !== null && isOpenPreviously !== undefined ? isOpenPreviously === 'true' : props.defaultIsOpen);

const isMobile = ref(window.innerWidth < 1024);
if(isMobile.value) {
  isOpen.value = false;
}

const toogleOpen = () => {
  isOpen.value = !isOpen.value;
  localStorage.setItem(fullDrawerName, isOpen.value);
}

</script>

<style scoped>

</style>